import { render } from "./trades.vue?vue&type=template&id=468c95f8"
import script from "./trades.vue?vue&type=script&lang=js"
export * from "./trades.vue?vue&type=script&lang=js"

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__